import { writable } from 'svelte/store';

const store = writable({
    profile_opened: false,
    reservation_opened: false,
    reservation_withCredits: false,
    sign_opened: false,
    credits_opened: false,
    event_opened: false,
    event_item: null,
    survey_opened: false,
    survey_item: null,
    order_opened: false,
    order_withCredits: false,
    order_item: null
});

export default {
    subscribe: store.subscribe,

    toggleProfileModal(state) {
        store.update(opts => {
            opts.profile_opened = state;
            return opts;
        });
    },

    toggleSignModal(state) {
        store.update(opts => {
            opts.sign_opened = state;
            return opts;
        });
    },

    toggleEventModal(event) {
        store.update(opts => {
            opts.event_opened = !!event;
            opts.event_item = !event ? null : event;
            return opts;
        });
    },

    toggleSurveyModal(survey) {
        store.update(opts => {
            opts.survey_opened = !!survey;
            opts.survey_item = !survey ? null : survey;
            return opts;
        });
    },

    toggleReservationModal(state, withCredits) {
        store.update(opts => {
            opts.reservation_opened = state;
            opts.reservation_withCredits = !!withCredits;
            return opts;
        });
    },

    toggleOrderModal(recording, withCredits) {
        store.update(opts => {
            opts.order_opened = !!recording;
            opts.order_withCredits = !!withCredits;
            opts.order_item = !recording ? null : recording;
            return opts;
        });
    },

    toggleCreditsModal(state) {
        store.update(opts => {
            opts.credits_opened = state;
            return opts;
        });
    }
};